import PolygonRenderer from "modules/construction-work/src/Entity/Map/PolygonRenderer";
import MarkerRenderer from "modules/construction-work/src/Entity/Map/MarkerRenderer";
import LineRenderer from "modules/construction-work/src/Entity/Map/LineRenderer";
import GeometryRendererAbstract from "modules/construction-work/src/Entity/Map/GeometryRendererAbstract";
import { MARKER_CONFIGS } from "modules/construction-work/src/Common/const/MarkerConfigsConst";
import {
    Geometry,
    LineString,
    Marker,
    Polygon,
} from "maptalks";

export default class GeometryRendererFactory {
    private renderers: Map<Function, GeometryRendererAbstract> = new Map();

    constructor() {
        this.renderers.set(Polygon, new PolygonRenderer(MARKER_CONFIGS.polygon));
        this.renderers.set(Marker, new MarkerRenderer(MARKER_CONFIGS.marker));
        this.renderers.set(LineString, new LineRenderer(MARKER_CONFIGS.lineString));
    }

    getRenderer(geometry: Geometry): GeometryRendererAbstract | null {
        for (const [GeometryClass, renderer] of this.renderers) {
            if (geometry instanceof GeometryClass) {
                return renderer;
            }
        }
        return null;
    }
}